if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {};
}

var _learnq = _learnq || [];

function _promiseChange(parameters) {
  let promiseRequest = $.ajax(parameters);

  // If offline, provide a rejected promise so that an error is thrown.
  if (navigator && !navigator.onLine) {
    promiseRequest = $.Deferred().reject();
  }

  return (
    promiseRequest
      // Some cart API requests don't return the cart object. If there is no
      // cart object then get one before proceeding.
      .then(
        (state) => {
          if (typeof state.token === 'undefined') {
            return getCart();
          } else {
            return state;
          }
        },
      )
      .then(saveLocalState)
  );
}

function _isLocalStorageSupported() {
  const mod = 'localStorageTest';
  try {
    localStorage.setItem(mod, mod);
    localStorage.removeItem(mod);
    return true;
  } catch (error) {
    return false;
  }
}

function saveLocalState(state) {
  if (_isLocalStorageSupported()) {
    localStorage.shopify_cart_state = JSON.stringify(state); // eslint-disable-line camelcase
  }

  return state;
}

function getLocalState() {
  // eslint-disable-line consistent-return
  if (_isLocalStorageSupported()) {
    return JSON.parse(localStorage.shopify_cart_state || '');
  }

  return '';
}

function between(x, min, max) {
  return x >= min && x <= max;
}

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = ShopifyAPI.addItemFromForm || function (form, callback, errorCallback) {
  var formData = new FormData(form);
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    processData: false,
    contentType: false,
    dataType: 'json',
    success: function (line_item) {
      if (typeof callback === 'function') {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  $.ajax(params);
};

ShopifyAPI.addItem = function (line_item, quantity) {

  if (!line_item) return;

  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: (!quantity) ? 1 : quantity,
      id: line_item,
    },
    dataType: 'json',
    success: function (line_item) {
      if (typeof callback === 'function') {
        callback(line_item);
      } else {
        ShopifyAPI.onItemAdded();
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };

  $.ajax(params);
};

ShopifyAPI.removeItem = function (line_item) {
  if (!line_item) return;

  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: {
      quantity: 0,
      id: line_item,
    },
    dataType: 'json',
    success: function (line_item) {
      if (typeof callback === 'function') {
        callback(line_item);
      } else {
        ShopifyAPI.onItemAdded();
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };

  $.ajax(params);
}

ShopifyAPI.onItemAdded = function () {

  switch (window.theme.settings.cartType) {
    case 'page':
      window.ShopifyAPI.onCartUpdate();
      break;

    case 'drawer':
      timber.RightDrawer.open();
      ajaxCart.load();
      break;
  }

};

ShopifyAPI.onCartUpdate = function () {

  const dataSelector = {
    cart: '[data-shopping-cart]',
    cartCheckout: '[data-shopping-cart-checkout]',
    cartTotal: '[data-shopping-cart-total]',
    cartWeight: '[data-shopping-cart-weight]',
    cartItems: '[data-shopping-cart-items]',
    cartEmpty: '[data-shopping-cart-empty]',
    cartFooter: '[data-shopping-cart-footer]',
    cartContinue: '[data-shopping-cart-continue]',
    cartText: '[data-cart-item-text]',
    cartDropdown: '[data-cart-item-dropdown]',
    giftCombo: '[data-gift-combo]',
    cartLink: '[data-cart-link]'
  }

  function cartItemsTemplate(products = []) {
    let items = '';

    products.forEach((product) => {

      items += `<li class="line-item" data-item="${product.id}">
      <a href="${product.url}" class="item-image" title="${product.title}">
        <img src="${ShopifyAPI.getSizedImageUrl(product.featured_image ? product.featured_image.url : product.image, '50x')}" alt="${product.title}">
      </a>
      <div class="item-meta">                       
        <a href="${product.url}" class="item-title">${product.title}</a>
        <span class="item-vendor"><a href="/collections/vendors?q=${product.vendor}" title="${product.vendor}">${product.vendor}</a></span>
        <span class="item-price"><span class="money">${ShopifyAPI.formatMoney(product.price, 'R{{amount}}')}</span></span>
        <span class="item-quantity">Quantity: ${product.quantity}</span>
      </div>
      <div class="item-button">
        <button class="button button-close" data-shopping-cart-remove="${product.key}">
          <svg class="icon icon-trash" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
          <g>
            <path fill="#AEB0B3" d="M6.876,22.64h10.247l1.305-16.908H5.572L6.876,22.64z M17.576,23.616H6.425
              c-0.254,0-0.467-0.195-0.486-0.449L4.559,5.281C4.547,5.146,4.595,5.012,4.687,4.912C4.779,4.812,4.91,4.755,5.045,4.755h13.91
              c0.137,0,0.266,0.057,0.359,0.157c0.094,0.1,0.141,0.234,0.127,0.369l-1.379,17.886C18.043,23.421,17.832,23.616,17.576,23.616"/>
            <path fill="#AEB0B3" d="M12,21.19c-0.269,0-0.489-0.219-0.489-0.488V7.669c0-0.269,0.22-0.487,0.489-0.487
              c0.27,0,0.488,0.218,0.488,0.487v13.033C12.488,20.972,12.27,21.19,12,21.19"/>
            <path fill="#AEB0B3" d="M9.316,20.945c-0.257,0-0.472-0.2-0.487-0.459L8.097,8.188c-0.016-0.27,0.189-0.501,0.458-0.517
              c0.269-0.016,0.5,0.189,0.517,0.458L9.803,20.43c0.017,0.269-0.188,0.499-0.457,0.516C9.335,20.945,9.326,20.945,9.316,20.945"/>
            <path fill="#AEB0B3" d="M14.686,20.945c-0.01,0-0.02,0-0.031,0c-0.268-0.017-0.471-0.247-0.457-0.516l0.734-12.301
              c0.014-0.269,0.244-0.474,0.514-0.458c0.271,0.016,0.473,0.247,0.459,0.517l-0.732,12.298
              C15.156,20.745,14.941,20.945,14.686,20.945"/>
            <path fill="#AEB0B3" d="M4.495,3.54c-0.194,0-0.354,0.158-0.354,0.352v0.511c0,0.195,0.159,0.352,0.354,0.352h15.013
              c0.191,0,0.35-0.157,0.35-0.352V3.892c0-0.193-0.158-0.352-0.35-0.352H4.495z M19.508,5.731H4.495
              c-0.733,0-1.329-0.595-1.329-1.329V3.892c0-0.732,0.596-1.327,1.329-1.327h15.013c0.73,0,1.326,0.595,1.326,1.327v0.511
              C20.834,5.136,20.238,5.731,19.508,5.731"/>
            <path fill="#AEB0B3" d="M10.217,2.563h3.566V1.529c0-0.092-0.076-0.168-0.168-0.168h-3.229c-0.093,0-0.168,0.076-0.168,0.168V2.563
              z M14.271,3.54H9.729c-0.271,0-0.488-0.218-0.488-0.488V1.529c0-0.632,0.514-1.145,1.145-1.145h3.229
              c0.631,0,1.145,0.513,1.145,1.145v1.523C14.76,3.322,14.541,3.54,14.271,3.54"/>
          </g>
          </svg>
        </button>
      </div>
      </li>`;

    });

    return items;

  }

  function addGiftsToCart(giftProduct, cart) {
    if (!giftProduct) {
      return
    }
    
    const productID = giftProduct.productID;
    const giftValue =  giftProduct.value;

    const lineItems = cart.items;
    const cartTotalPrice = cart.total_price;

    const giftInCart = lineItems.filter((lineitem) => {
      return lineitem.id === productID;
    });

    if (giftInCart.length === 0 && cartTotalPrice >= giftValue) {
      window.ShopifyAPI.addItem(productID, 1);
    } else if (giftInCart.length > 0 && cartTotalPrice < giftValue) {
      window.ShopifyAPI.removeItem(productID);
    }

  }

  window.ShopifyAPI.getCart().then((cart) => {


    var itemCountString = cart.item_count;

    if (itemCountString > 1) {
      itemCountString = itemCountString + ' items';
    } else {
      itemCountString = itemCountString + ' item';
    }

    const emptyCartTemplate = '<div class="shopping-cart-items text-center empty" data-shopping-cart-empty>Your cart is currently empty.</div>';
    const cartBubble = `<div class="cart-count-bubble">${cart.item_count < 100 ? cart.item_count : '' }<span class="visually-hidden">${ itemCountString }</span></div>`;

    if ($(dataSelector.giftCombo).length) {

      const giftProducts = JSON.parse($(dataSelector.giftCombo).text());

      addGiftsToCart(giftProducts, cart);
    }

    console.log(dataSelector.cartLink + ' .cart-count-bubble')
    
    $(dataSelector.cartLink + ' .cart-count-bubble').remove();

    $(dataSelector.cartLink).append(cartBubble);

    if (cart.item_count > 0) {
      const productItems = cartItemsTemplate(cart.items);

      if ($(dataSelector.cartEmpty).length >= 1) {
        $(dataSelector.cartEmpty).replaceWith(`<ul class="shopping-cart-items" data-shopping-cart-items>${productItems}</ul>`);
      } else {
        $(dataSelector.cartItems).html(productItems);
      }

      if ($(dataSelector.cartCheckout).is(':disabled')) {
        $(dataSelector.cartCheckout).removeAttr('disabled');
      }

      if ($(dataSelector.cartCheckout).prop('nodeName') === 'BUTTON') {
        $(dataSelector.cartCheckout).replaceWith(`<a href="/cart" class="btn btn--secondary" data-shopping-cart-checkout>Checkout</a>`);
      }

      $(dataSelector.cartDropdown).addClass('active');

      if (window.location.pathname !== '/cart') {
        $(dataSelector.cart).addClass('flash');

        window.setTimeout(() => {
          $(dataSelector.cart).removeClass('flash');
        }, 4000);
      }

    } else {

      $(dataSelector.cartItems).replaceWith(emptyCartTemplate);
      $(dataSelector.cartDropdown).removeClass('active');

      if ($(dataSelector.cartCheckout).prop('nodeName') === 'A') {
        $(dataSelector.cartCheckout).replaceWith('<button class="btn btn-primary" disabled="" data-shopping-cart-checkout="">Checkout</button>');
      }

    }

    $(dataSelector.cartText).html(`Cart / ${cart.item_count}`);
    $(dataSelector.cartTotal).html(`<span class="money">${ShopifyAPI.formatMoney(cart.total_price)}</span>`);
    $(dataSelector.cartWeight).html(ShopifyAPI.formatWeight(cart.total_weight));

  });

};

ShopifyAPI.removeProtocol = function (path) {
  return path.replace(/http(s)?:/, '');
}

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  const data = eval('(' + XMLHttpRequest.responseText + ')');
  window.console.error(data.message + '(' + data.status + '): ' + data.description);
},

  Shopify.handleize = function (str) {
    str = str.toLowerCase();

    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
    }

    return str
  };

Shopify.queryParams = function () {
  Shopify.urlParams = {};
  if (window.location.search.length) {
    for (let aKeyValue, i = 0, aCouples = window.location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.urlParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  return Shopify.urlParams;
}

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

const moneyFormat = 'R{{amount}}';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
ShopifyAPI.formatMoney = function (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

Shopify.money_format = '{{amount}} Kg';

ShopifyAPI.formatWeight = function (total_weight, unit) {

  if (isNaN(total_weight) || total_weight == null) { return 0; }

  var value = '';

  if (unit && typeof unit === 'string') {
    Shopify.money_format = '{{amount}} ' + unit;
  }

  function format(number) {
    return (number * 0.001).toFixed(2);
  }

  value = format(total_weight);

  return Shopify.money_format.replace('{{amount}}', value);
}

Shopify.Product = Shopify.Product || {};

Shopify.Product.soldOut = function (product) {
  return product.available;
}

Shopify.Product.onSale = function (product) {
  return product.compare_at_price > product.price;
}

Shopify.formValidate = function (string) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(string));
}


/**
 * Find the Shopify image attribute size
 *
 * @param {string} src
 * @returns {null}
 */
ShopifyAPI.imageSize = function (src) {
  const match = src.match(
    /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
  );

  if (match) {
    return match[1];
  } else {
    return null;
  }
}

/**
 * Adds a Shopify size attribute to a URL
 *
 * @param src
 * @param size
 * @returns {*}
 */
ShopifyAPI.getSizedImageUrl = function (src, size) {
  if (size === null) {
    return src;
  }

  if (size === 'master') {
    return removeProtocol(src);
  }

  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[0];

    return ShopifyAPI.removeProtocol(`${prefix[0]}_${size}${suffix}`);
  } else {
    return null;
  }
}

ShopifyAPI.getCart = function () {
  return $.getJSON('/cart.js');
}

ShopifyAPI.changeItem = function (id, quantity) {

  const requestSettings = {
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      id,
      quantity,
    },
  };

  return _promiseChange(requestSettings);
}

theme.getShippingData = function (shippingData) {
  if (!shippingData) return;

  const { tracking_company } = JSON.parse(shippingData);

  const params = {
    type: 'POST',
    url: 'https://planet54-tracking.herokuapp.com/',
    data: shippingData,
    dataType: 'json',
    success: function (response) {
      const { status, payload } = response;

      if (status && status === 200) {
        theme.handleShippingData(Shopify.handleize(tracking_company), payload);
      }

    },
    error: function (XMLHttpRequest, textStatus) {
      window.console.error('getShippingData() - XMLHttpRequest', XMLHttpRequest);
      window.console.error('getShippingData() - textStatus', textStatus);
    }
  };


  $.ajax(params);

}

theme.handleShippingData = function (courier, data) {
  if (!data || data.length === 0) return;

  const shippingSteps = {
    onItsWay: false,
    outForDelivery: false,
    delivered: false,
    failedDeliveryAttempt: false
  };

  let shippingLineItems = [];

  switch (courier) {
    case 'bex':
      shippingLineItems = Object.values(data)[0];
      break;
    case 'aramex':
      shippingLineItems = data['Value']['TrackingResult'];
      break;
    default:
      shippingLineItems = data;
      break;
  }

  shippingLineItems.forEach((item) => {

    if (
      item.action && item.action === 'IMPORTED' ||
      item.description && item.description === 'Shipment handed to courier' ||
      item.UpdateCode && item.UpdateCode === 'SH047'
    ) {
      shippingSteps.onItsWay = 1;
    }

    if (
      item.action && item.action === 'WBLALD' ||
      item.description && item.description === 'Loaded onto vehicle for delivery' ||
      item.UpdateCode && item.UpdateCode === 'SH003') {

      shippingSteps.outForDelivery = moment((item.UpdateDateTime) ? item.UpdateDateTime : item.date).format('DD MMMM');
    }

    if (
      item.action && item.action === 'WBLDLV' ||
      item.description && item.description.indexOf('Delivered to') > -1 ||
      item.UpdateCode && item.UpdateCode === 'SH005'
    ) {
      shippingSteps.delivered = moment(item.date).format('MMMM DD');
    }

    if (item.UpdateCode && item.UpdateCode === 'SH033') {
      shippingSteps.failedDeliveryAttempt = true;
      $('[data-shipping-message]').html(`<div class="errors"><p class="h5">Order Delivery attempt on ${moment(item.UpdateDateTime).format('MMMM DD, YYYY at HH:mm a')}</p><p>Reason: ${item.UpdateDescription}</p></div>`)
    }

  });

  if (shippingSteps.onItsWay) {
    $('.os-timeline-step').removeClass('os-timeline-step--current');
    $('[data-shipping-step-two]').addClass('os-timeline-step--selected').addClass('os-timeline-step--current');
  }

  if (shippingSteps.outForDelivery) {
    $('.os-timeline-step').removeClass('os-timeline-step--current');
    $('[data-shipping-step-three]').addClass('os-timeline-step--selected').addClass('os-timeline-step--current');;
    $('[data-shipping-step-three]').find('.os-timeline-step__date').html(shippingSteps.outForDelivery);
  }

  if (shippingSteps.delivered) {
    $('.os-timeline-step').removeClass('os-timeline-step--current');
    $('[data-shipping-step-four]').addClass('os-timeline-step--selected').addClass('os-timeline-step--current');;

    if (shippingSteps.failedDeliveryAttempt) {
      $('[data-shipping-message]').html('');
      shippingSteps.failedDeliveryAttempt = false;
    }
  }

  if (shippingSteps.delivered && !shippingSteps.onItsWay && !shippingSteps.outForDelivery) {
    $('.os-timeline-step').removeClass('os-timeline-step--current');
    $('[data-shipping-step-two]').addClass('os-timeline-step--selected').addClass('os-timeline-step--current');
    $('[data-shipping-step-three]').addClass('os-timeline-step--selected').addClass('os-timeline-step--current');;
    $('[data-shipping-step-three]').find('.os-timeline-step__date').html(shippingSteps.outForDelivery);
  }
}

const sliderButtonLeft = '<button class="custom-buttons slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"><polygon points="14,19.8 4.4,10.2 14.4,0.2 15.6,1.3 6.7,10.2 15.2,18.7 	"/></svg></button>';

const SliderButtonRight = '<button class="custom-buttons slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"> <polygon points="6,19.8 15.6,10.2 5.6,0.2 4.4,1.3 13.3,10.2 4.8,18.7 	"/></svg></button>';

const selectors = {
  singleProductStyleCode: '[data-single-option-radio-color]',
  product: '[data-product-json]',
  productColorHandle: '[data-color-handle]',
  productHeading: '[data-product-section-toggle]',
  collectionButtonVariantID: '[data-variant-button-id]',
  collectionSelectSizeButton: '[data-select-size-button]',
  collectionSelectVariant: '[data-select-variant]',
  createCustomerForm: '[data-create-customer-form]',
  customfields: '[data-customfields]',
  customertags: '[data-customertags]',
  submit: '[data-create-customer-submit]',
  termsCheckbox: '[data-terms]',
  termsNewsletterCheckbox:'[data-terms-newsletter]',
  contactTags: '[data-contact-tags]',
  newsletterForm: '[data-newsletter-form]',
  newsletterSubscribeButton: '[data-newsletter-subscribe]',
  trackingObject: '[data-tracking-object]',
  countDownTimer: '[data-countdown-timer]',
  days: '[data-days]',
  hours: '[ data-hours]',
  min: '[data-min]',
  sec: '[data-sec]',
  accountTab: '[data-account-tab]',
  accountSection: '[data-account-section]',
  menuClock: '[data-menu-clock]',
  lineItemQuantityUpdate: '[data-line-item-update]',
  cartPrice: '[data-cart-price]',
  cartWeight: '[data-cart-weight]',
  updateCartButton: ['[data-update-cart-button]'],
  charityData: '[data-charity]',
  buttonCheckout: '[data-button-checkout]',
  cartRemove: '[data-shopping-cart-remove]',
};

const cssSelectors = {
  singleOptionSelector: '.single-option-selector__radio',
  countdownSection: '#shopify-section-countdown-timer',
  announcementBar_message: '.announcement-bar__message',
  create_customer: '#create_customer',
};

const arrowButtons = {
  left: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"><polygon points="14,19.8 4.4,10.2 14.4,0.2 15.6,1.3 6.7,10.2 15.2,18.7 "/></svg></button>',
  right: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve"> <polygon points="6,19.8 15.6,10.2 5.6,0.2 4.4,1.3 13.3,10.2 4.8,18.7 "/></svg></button>',
};

const toAddToCart = {
  set: function (key) {
    if (!localStorage.getItem('ToAddToCart')) {
      localStorage.setItem('ToAddToCart', JSON.stringify([key]));
    } else {
      let toAddToCartArray = JSON.parse(localStorage.getItem('ToAddToCart'));
      toAddToCartArray.push(key);
      localStorage.setItem('ToAddToCart', JSON.stringify(toAddToCartArray));
    }

    return JSON.parse(localStorage.getItem('ToAddToCart'));
  },
  get: function () {

    if (!localStorage.getItem('ToAddToCart')) {
      return false;
    }

    return JSON.parse(localStorage.getItem('ToAddToCart'));
  },
  remove: function () {
    localStorage.removeItem('ToAddToCart');
  }
}

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

var customerRegistration = {
  process: function () {
    const $customertags = $(selectors.customertags);

    const fieldsArray = [];

    $(selectors.customfields).each(function () {

      if ($(this).val() !== '') {
        fieldsArray.push($(this).val());
      }

    });

    if ($(selectors.termsNewsletterCheckbox).is(':checked')) {
      fieldsArray.push('newsletter');
    }

    $customertags.val(fieldsArray.join(', '));

    if (typeof fbq !== 'undefined') {
      fbq('track', 'CompleteRegistration', { content_name: 'account/register', currency: 'ZAR', value: 0 });
    }

    $(cssSelectors.create_customer).submit();
  },
  init: function () {
    const $termsInput = $(selectors.termsCheckbox);
    const $termsNewsletterInput = $(selectors.termsNewsletterCheckbox);
    const $submit = $(selectors.submit);

    if ($termsInput.is(':checked') === false) {
      $submit.attr('disabled', true);
    }

    $termsInput.on('change', function () {
      if ($(this).is(':checked')) {
        $submit.removeAttr('disabled');
      } else {
        $submit.attr('disabled', true);
      }
    });

    $(selectors.submit).on('click', function (evt) {
      evt.preventDefault();

      if ($(selectors.termsCheckbox).is(':checked') === false) {
        window.alert('You must agree with the terms and conditions to register.');
        return;
      }

      customerRegistration.process();
    });

  }
}

const ShopTheLook = {
  get: function (styleCode) {
    if (!styleCode) return;

    $.get(`/collections/all/${Shopify.handleize(styleCode)}`, { view: 'json' }, function (collection) {
      const { products } = JSON.parse(collection);
      if (products.length > 1) {
        $('[data-shop-the-look-wrapper]').removeClass('hide');
        ShopTheLook.loadProducts(products.slice(0, 10));
      }
    });
  },

  productVariantsTemplate(product) {

    if (!product) return '';

    const { id, variants } = product;

    if (variants.length === 1) {
      return `<button type="button" name="add" id="AddToCart--${product.id}" class="btn btn--add-to-cart btn--secondary-accent btn--collection-product" data-variant-button-id="${variants[0].id}" title="Add ${product.title} to cart"><span class="btn__text">Add to Cart</span></button>`;
    }

    let options = '';

    variants.forEach((variant) => {

      options = options.concat(`<span class="variant--option${(!variant.available) ? ' disabled' : ''}" data-select-variant="${variant.id}">${variant.option2}</span>`);

    });

    return `<div class="select-size"><button type="button" class="select-size-button" data-select-size-button="">Select a size<span class="toggle"></span></button><div class="variants hide" data-variants-options>${options}</div></div>`;

  },

  productTemplate(product) {

    return `<div class="grid__item one-half large--one-quarter">
    <div class="grid-product__wrapper">
      <div class="grid-product__image-wrapper">
        <a href="/products/${product.handle}" class="grid-product__image-link">
          <img class="grid-product__image" src="${ShopifyAPI.getSizedImageUrl((product.media.length > 1) ? product.media[1].preview_image.src : product.featured_image, '1024x')}">
        </a>
      </div>
      <div class="grid-product__meta">
        <a href="/products/${product.handle}">
          <span class="grid-product__title">${product.title}</span>
        </a>
        <p><a href="/collections/vendors?q=#${Shopify.handleize(product.vendor)}">${product.vendor}</a></p>
        
        ${ShopTheLook.productVariantsTemplate(product)}

        <a href="/products/${product.handle}" title="${product.title}">
          <div class="grid-product__price hide">
          ${(product.compare_at_price > product.price) ? `<span class="p-sale"><strike>${ShopifyAPI.formatMoney(product.compare_at_price)}</strike></span><span class="p-price s-price">${ShopifyAPI.formatMoney(product.price)}</span>` : `<span class="p-price">${ShopifyAPI.formatMoney(product.price)}</span>`}
          </div>
        </a>
      </div>
    </div>
  </div>`;
  },

  loadProducts(products) {

    if (!products) return;

    let templateItems = [];

    products.forEach(product => {

      if (!product.available) return;

      templateItems.push(ShopTheLook.productTemplate(product));

    });

    $('[data-product-shop-the-look]').html(templateItems);

  },
};

function whenAvailable(name, callback) {
  var interval = 10; // ms
  window.setTimeout(function () {
    if (window[name]) {
      callback(window[name]);
    } else {
      whenAvailable(name, callback);
    }
  }, interval);
}

function timerFn(settings = false, timer = false) {
  if (!timer || !settings) {
    return;
  }

  const current_handle = settings.handle;
  const { date, message, sale_url, localized } = timer;

  if (localized.length !== 0) {
    if (current_handle !== localized) {
      return;
    }
  }

  const eventTime = moment(date).unix();
  const currentTime = moment().unix();
  const diffTime = eventTime - currentTime;
  let duration = moment.duration(diffTime, 'seconds');
  const interval = 1000;

  // If it is time for count down
  if (diffTime > 0) {

    const template = `
    <style type="text/css">
      #counter-timer-${timer.id} .counterdown-wrapper {
        color: ${timer.text_color};
      }
      
      #counter-timer-${timer.id} .counterdown-wrapper .unit {
        border:2px solid ${timer.text_color};
      }

      #counter-timer-${timer.id} .counterdown-wrapper .number {
        display: block;
        color:${timer.timer_color};
        border-bottom: 2px solid ${timer.text_color};
      } 
      
      #counter-timer-${timer.id} {
        background-color:${timer.textarea_background_color};
      }

      #counter-timer-${timer.id} p {
        color:${timer.textarea_color};
      }
    </style>
    ${(sale_url.length > 0) ? `<a href="${sale_url}">` : ''}
    <div id="counter-timer-${timer.id}">
      <div class="grid no-gutters">
        <div class="grid__item large--four-twelfths" style="background-color:${timer.timer_background_color}; color:${timer.text_color};">
          <div class="counterdown-wrapper">
            <span class="unit days" data-days></span>
            <span class="unit hours" data-hours></span>
            <span class="unit min" data-min></span>
            <span class="unit sec" data-sec></span>
          </div>
        </div>
        ${(message.length > 0) ? `<div class="grid__item large--eight-twelfths timer-textarea"><p>${message}</p></div>` : ''}
      </div>
    </div>
      ${(sale_url.length > 0) ? '</a>' : ''}
    `;

    $countdownSection = $(cssSelectors.countdownSection);

    // To show the clock
    $countdownSection.append(template);

    if (window.innerWidth > 767) {
      $(selectors.menuClock).html($countdownSection).removeClass('hide');
    }

    const windowInterval = window.setInterval(() => {

      duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
      const days = moment.duration(duration).days();
      const hours = moment.duration(duration).hours();
      const minutes = moment.duration(duration).minutes();
      const seconds = moment.duration(duration).seconds();

      $(selectors.days).html(`<span class="number">${(days < 10) ? `0${days}` : days}</span> <span class="label">Days</span>`);

      if (days === 0 && minutes <= 5) {
        if (!$(cssSelectors.countdownSection).hasClass('flashs')) {
          $(cssSelectors.countdownSection).addClass('flash');
        }
      }

      if (days === 0 && minutes === 0 && seconds <= 0) {
        $(cssSelectors.countdownSection).remove();
        window.clearInterval(windowInterval);
      }

      $(selectors.hours).html(`<span class="number">${(hours < 10) ? `0${hours}` : hours}</span> <span class="label">Hours</span>`);
      $(selectors.min).html(`<span class="number">${(minutes < 10) ? `0${minutes}` : minutes}</span> <span class="label">Min</span>`);
      $(selectors.sec).html(`<span class="number">${(seconds < 10) ? `0${seconds}` : seconds}</span> <span class="label">Sec</span>`);

    }, interval);
  }

}

function countdown() {

  if (!$(selectors.countDownTimer)) {
    return;
  }

  const object = JSON.parse($(selectors.countDownTimer).html());

  let { options } = object;

  // Filter items that aren't meant to show
  options = options.filter((item) => {
    return item.show;
  });

  // Return items with no localization set
  const globalTimers = options.filter((item) => {
    return item.localized.length === 0;
  });


  // Return items with width localization set
  const LocalizedTimers = options.filter((item) => {
    return item.localized.length > 0;
  });

  if (globalTimers.length === 0) {
    LocalizedTimers.forEach((item) => {
      timerFn(object.settings, item);
    });
    return;
  }

  timerFn(object.settings, globalTimers[0]);
}

function timer() {

  const timers = $('[data-timer]');

  if (!timers.length) {
    return;
  }

  $(timers).each(function (timer) {
    const date = $(this).data('timer');
    const eventTime = moment(date).unix();
    const currentTime = moment().unix();
    const diffTime = eventTime - currentTime;
    let duration = moment.duration(diffTime, 'seconds');
    const interval = 1000;

    $days = $(this).find('[data-time-days]');
    $hours = $(this).find('[data-time-hours]');
    $minutes = $(this).find('[data-time-minutes]');
    $seconds = $(this).find('[data-time-seconds]');

    if (diffTime > 0) {
      const windowInterval = window.setInterval(() => {

        duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
        const days = moment.duration(duration).days();
        const hours = moment.duration(duration).hours();
        const minutes = moment.duration(duration).minutes();
        const seconds = moment.duration(duration).seconds();

        if (days !== 0) {
          $(selectors.days).html(`${days} Days`);
        }

        /*
        if (days === 0 && minutes <= 5) {
          if (!$(cssSelectors.countdownSection).hasClass('flashs')) {
            $(cssSelectors.countdownSection).addClass('flash');
          }
        }
        */

        if (days === 0 && minutes === 0 && seconds <= 0) {
          $(cssSelectors.countdownSection).remove();
          window.clearInterval(windowInterval);
        }

        $days.html(`${(days < 10) ? `0${days}` : days}`);
        $hours.html(`${(hours < 10) ? `0${hours}` : hours}`);
        $minutes.html(`${(minutes < 10) ? `0${minutes}` : minutes}`);
        $seconds.html(`${(seconds < 10) ? `0${seconds}` : seconds}`);

      }, interval);
    }


  });

}

function collection_slider() {
  const select = {
    collectionSlider: '[data-collection-slider]',
    collectionPicks: '[data-picks-slider]',
    collectionBrands: '[data-brand-slider]',
    productSlider: '[data-product-slider]',
    productImageSlider: '[single-product-image-slider]',
    shopByBrandSlider: '[data-shop-by-brand-slider]',
    featuredCollectionSlider: '[data-featured-collection-slider]',
  }

  $(select.collectionSlider).slick({
    dots: true,
    infinite: false,
    speed: 300,
    prevArrow: sliderButtonLeft,
    nextArrow: SliderButtonRight,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
        },
      }
    ]
  });

  $(select.collectionPicks).slick({
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 2,
    infinite: false,
    prevArrow: sliderButtonLeft,
    nextArrow: SliderButtonRight,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      }
    ]
  });

  let slidesToShow = 6;

  if ($('[ data-slides-to-show]').length && $('[ data-slides-to-show]').attr('data-slides-to-show').length) {
    slidesToShow = parseInt($('[ data-slides-to-show]').attr('data-slides-to-show'));
  }

  $(select.featuredCollectionSlider).slick({
    dots: false,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToShow,
    infinite: false,
    prevArrow: sliderButtonLeft,
    nextArrow: SliderButtonRight,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      }
    ]
  });

  $(select.collectionBrands).slick({
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 2,
    infinite: false,
    prevArrow: sliderButtonLeft,
    nextArrow: SliderButtonRight,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      }
    ]
  });

  $(select.productSlider).slick({
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 2,
    infinite: false,
    prevArrow: sliderButtonLeft,
    nextArrow: SliderButtonRight,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      }
    ]
  });

  $(select.shopByBrandSlider).slick({
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 2,
    infinite: false,
    speed: 300,
    prevArrow: sliderButtonLeft,
    nextArrow: SliderButtonRight,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
        },
      }
    ]
  });

}

function toggles() {
  const select = {
    toggle: '[data-toggle]',
    shopToggle: '[data-shop-toggle]',
  }

  const cssSelect = {
    shopByItemBlock: '.shop-by-item-block',
  }

  $(select.toggle).on('click', function () {
    $('.trends-block').addClass('hide');
    $(`[data-trend="${$(this).data('toggle')}"]`).toggleClass('hide');
  });

  $(document).on('click', '[data-show-more]', function () {

    $(this).addClass('hide');
    $(`[data-show='${$(this).data('show-more')}']`).toggleClass('hide');

  });

  $(document).on('click', '[data-show-more-inner]', function () {

    var id = $(this).data('show-more-inner');
    var scrollPosition = $(`.collection-section--${id}`).offset().top;

    $(`[data-show-more="${id}"]`).removeClass('hide');

    $([document.documentElement, document.body]).animate({
      scrollTop: scrollPosition
    }, 1000);

    $(`[data-show="${id}"]`).toggleClass('hide');
  });

  $(select.shopToggle).on('click', function (evt) {
    evt.preventDefault();

    $(cssSelect.shopByItemBlock).addClass('hide');

    $(`[data-shop-by="${$(this).data('shopToggle')}"]`).toggleClass('hide');
  });

  $(document).on('click', '.product-tile__toggle-alternate-image--left', function(evt) {
    evt.preventDefault();

    $(this).parent()
    .removeClass('product-tile__image-line--alternate-visible')
    .addClass('product-tile__image-line--primary-visible');
  });

  $(document).on('click', '.product-tile__toggle-alternate-image--right', function(evt) {
    evt.preventDefault();
   
    $(this).parent()
    .addClass('product-tile__image-line--alternate-visible')
    .removeClass('product-tile__image-line--primary-visible');
  });

  
  $('#payflex-more-info').click(function() {
    $(window).scrollTop(0);
    $('#partPayCalculatorWidgetDialog').show();
  });

  $('#payjustnowinfo').click(function() {
    $(window).scrollTop(0);
    $('#pjn-popup').show();
  });
}

function sortBy() {
  const defaultSortBy = $('#sort-by').data('default');
  const labelText = $('#sort-by [data-text]');

  $('#sort-by .sortby-options li').on('click', function () {
    labelText.text($(this).text());
    Shopify.urlParams.sort_by = $(this).data('value');
    location.search = $.param(Shopify.urlParams).replace(/\+/g, '%20');
  });
}

function megaMenu() {

  if ($('[data-drawer-mega-menu]').length > 0) {

    if ($('[data-drawer-mega-menu]').length > 1) {
      $('[data-collection-menu]').replaceWith($($('[data-drawer-mega-menu]')[1]).html());
    } else {
      $('[data-collection-menu]').replaceWith($('[data-drawer-mega-menu]').html());
    }

    $('[data-drawer-mega-menu]').remove();
    $('[data-main-menu-title]').addClass('hide');
    $('[data-main-menu]').addClass('hide');

    var $toggleBtns = $('.mobile-nav__toggle-btn-extra');

    // Setup aria attributes
    $toggleBtns.attr('aria-expanded', 'false');

    $toggleBtns.each(function () {
      var $button = $(this);
      $button.attr('aria-controls', $button.attr('data-aria-controls'));
    });

    $toggleBtns.on('click', function () {
      var $button = $(this);
      var currentlyExpanded = $button.attr('aria-expanded');
      var toggleState = false;
      // Updated aria-expanded value based on state pre-click
      if (currentlyExpanded === 'true') {
        $button.attr('aria-expanded', 'false');
      } else {
        $button.attr('aria-expanded', 'true');
        toggleState = true;
      }

      // Toggle that expands/collapses sublist
      $button
        .closest('.mobile-nav__has-sublist')
        .toggleClass('mobile-nav--expanded', toggleState)
        .next()
        .slideToggle();
    });
  }
}

function signup() {
  const $signupWrapper = $('#signup-user');
  let delay = $signupWrapper.data('delay');
  const $signupForm = $('#signup_form');
  const $signupClose = $('#modal-close');
  const cookieTitle = 'planet54_popup-dismissed';

  if (!delay) {
    delay = 2000;
  }

  const openForm = function () {
    $signupWrapper.fadeIn(350).addClass('popup-open');
  }

  const closeForm = function () {
    $signupWrapper.fadeOut(350).removeClass('popup-open');
    window.localStorage.setItem(cookieTitle, true);
  }

  if (!window.localStorage.getItem(cookieTitle)) {
    window.setTimeout(() => {
      openForm();
    }, delay);
  } else {

    return false;

  }

  const $contactTags = $signupForm.find('[name="contact[tags]"]');
  $contactTagsValue = $contactTags.val();
  let tags = [];


  if (Shopify.urlParams.form_type === 'customer' || Shopify.urlParams.customer_posted) {
    $signupWrapper.fadeIn(350).addClass('popup-open');
  }

  $('[data-sign-up-button]').on('click', function (evt) {
    evt.preventDefault();

    tags = [$contactTagsValue, $(this).val()];

    $contactTags.val(tags.join(', '));

    $signupForm.submit();
  });

  $signupClose.on('click', function (evt) {
    evt.preventDefault();
    closeForm();
  });

}

function bfPopUp() {
  const $popup = $('#block-messenger-popup');
  const $popupClose = $('#block-messenger-popup-close');
  const message = '<div class="note form-success">Thank you for entering, please check your mail for the confirmation, emails may be found in your junk or spam.</div>';

  if (window.localStorage.getItem('P54_bf_entered')) {
    $('#block-messenger-popup .survey--form').html(message);
  }

  $popupClose.on('click', (evt) => {
    evt.preventDefault();

    $popup.addClass('hide');
  });

  $('[data-bf-signup-trigger], div[data-bf-signup-trigger] a').on('click', (evt) => {
    evt.preventDefault();
    $popup.removeClass('hide');
  });
}

async function fetchOrderAsync(ordernumber) {
  const response = await fetch(`https://planet54-orders.herokuapp.com/?order_number=${ordernumber}`);
  return await response.text();;
}

function loadOrder(orderNumber) {
  const ordersPromise = fetchOrderAsync(orderNumber);
  const $orderMessages = $('[data-order-messages]');
  const messages = {
    confirmation: 'We\'ve accepted your order, and we’re getting it ready. Come back to this page for updates on your shipment status.',
    notFound: 'Order number is not found, please contact customer support for further assistance'
  }

  ordersPromise.then((response) => {

    if (!response.length) {
      $orderMessages.text(messages.notFound).addClass('alert-warning').removeClass('hide');
      return;
    } else {
      if (!$orderMessages.hasClass('hide')) {
        $orderMessages.addClass('hide');
      }
    }

    const order = JSON.parse(response).payload.order;

    if (order.confirmed) {
      $('[data-shipping-timeline-wrapper]').removeClass('hide');
      $('[data-shipping-message]').html(`<p>${messages.confirmation}</p>`);
      $('[data-order-number]').val(orderNumber);

      order.fulfillments.forEach((fulfillment) => {
        $('[data-shipping-message]').append(`<div class="tracking-info">
          <div class="tracking-info__number">
            <strong>${fulfillment.tracking_company} tracking number:</strong>
              <p>
                <a aria-describedby="forwarding-external-new-window-message" data-tracking-number-link="true" target="_blank" href="${fulfillment.tracking_url}">${fulfillment.tracking_number}</a>
              </p>
          </div>
        </div>`);

        window.theme.getShippingData(JSON.stringify({ tracking_company: fulfillment.tracking_company, tracking_numbers: [fulfillment.tracking_number] }));
      });

    }

  }).catch((err) => {

    window.console.error(err);

    return err;
  });
}

function trackOrder() {

  const $inputOrderNumber = $('[data-order-number]');
  const { order_number } = Shopify.urlParams;

  if (order_number) {
    loadOrder(DOMPurify.sanitize(order_number));
  }

  $('[data-track-order-button]').on('click', (evt) => {
    evt.preventDefault();
    loadOrder(DOMPurify.sanitize($inputOrderNumber.val()));
  });

  $inputOrderNumber.on('keypress', (evt) => {
    const key = evt.which || evt.keyCode;
    if (key === 13) {
      loadOrder(DOMPurify.sanitize($inputOrderNumber.val()));
    }
  });
}

function singleProductVideos() {

  Shopify.videos = Shopify.videos || [];

  $('.product-single__video').each(function () {
    if ($(this).attr('data-image-id')) {
      Shopify.videos.push($(this).attr('data-image-id'));
      var video = $(this)[0];

      video.muted = true;
      video.controls = false;

      video.play();

      video.addEventListener('ended', function () {
        video.currentTime = 0;
        video.play();
      });
    }
  });

  // Play / pause current video
  $('.product-single__video').on('click', function () {
    var video = $(this)[0];

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }

  });

}

function loginToAddToCart() {

  if ($('body').hasClass('customer-logged-in') && toAddToCart.get() !== false) {
    var dataArray = [];
    var productIDArray = toAddToCart.get();

    productIDArray.forEach(function (id) {
      dataArray.push({
        quantity: 1,
        id: id
      })
    });

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: { items: dataArray },
      dataType: 'json',
      success: function (line_item) {
        if (typeof callback === 'function') {
          callback(line_item);
        } else {
          ShopifyAPI.onItemAdded();
        }
        toAddToCart.remove();
      },
      error: function (XMLHttpRequest, textStatus) {
        if (typeof errorCallback === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
      }
    };

    $.ajax(params);

    return;
  }

  const $modalWrapper = $('#login-modal');

  $('#login-modal--button-close').on('click', function (evt) {
    evt.preventDefault();
    $modalWrapper.addClass('hide');
  });

  $modalWrapper.on('click', function (evt) {
    if ($(evt.target).hasClass('login-modal')) {
      $(evt.target).addClass('hide');
      evt.stopPropagation();
    }
  });

  window.addEventListener('storage', (e) => {
    console.log(`Key Changed: ${e.key}`);
  });

}

function filterToggles() {
  const $fitlerTreeMobile = $('#bc-sf-filter-tree-mobile');

  if (!$fitlerTreeMobile.length) {
    return;
  }

  $(document).on('click', '#bc-sf-filter-tree-mobile-button', () => {
    $('#bc-sf-filter-tree-mobile-apply-button').toggle();
    $('#bc-sf-filter-top-sorting').toggle();
  });

  $(document).on('click', '#bc-sf-filter-tree-mobile-apply-button', (evt) => {
    $('#bc-sf-filter-tree').slideUp();
    $('#bc-sf-filter-tree-mobile-apply-button').hide();
    $('#bc-sf-filter-top-sorting').show();
  });

}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    console.log('this.header', this.header);
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

Shopify.queryParams();

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var P54 = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages

        /**
         * Countdown timer
         */
        whenAvailable('moment', function (t) {
          countdown();
          timer();
        });

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        sortBy();
        megaMenu();
        signup();
        bfPopUp();
        trackOrder();
        loginToAddToCart();
        filterToggles();

        // Payflex
        $(window).on('load', function () {
          if ($('#partPayCalculatorWidget1').length) {
            $('#partPayCalculatorWidget1').clone().appendTo('[data-payflex_widget_wrapper]');;
          }
        });

        $('.social-media--slider').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: arrowButtons.left,
          nextArrow: arrowButtons.right,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                infinite: false,
                adaptiveHeight: true,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true,
              },
            },
          ],
        });

        $('.product_type-slider').slick({
          slidesToShow: 4,
          slidesToScroll: 2,
          infinite: false,
          arrows: true,
          prevArrow: arrowButtons.left,
          nextArrow: arrowButtons.right,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: false,
                dots: true,
              },
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: false,
                dots: true,
              },
            },
            {
              breakpoint: 768,
              settings: 'unslick',
            },
          ],
        });

        $(selectors.accountTab).on('click', function () {

          $(selectors.accountSection).each(function () {
            if ($(this).hasClass('active')) {
              $('.account-menu--item').removeClass('active');
              $(this).removeClass('active').addClass('hide');
            }
          });

          const tab = $(this).data('account-tab');
          $(this).parent().addClass('active');
          $(`#${tab}`).removeClass('hide').addClass('active');
        })

        $(selectors.productHeading).on('click', function () {
          $(this).toggleClass('active');
          $(`[data-${$(this).data('product-section-toggle')}]`).toggleClass('hide');
        });

        $(document).on('change', selectors.collectionSelectVariant, function (evt) {
          evt.preventDefault();

          var selectedProductID = $(this).data('select-variant');
          var selectedValue = this.options[$(this).prop('selectedIndex')].getAttribute('value');
          var selectedQuantity = $('#Quantity' + selectedProductID).val();

          if (!window.theme.settings.loginToAddToCart) {

            if (!selectedValue || selectedValue.length != 0 && selectedValue) {
              window.ShopifyAPI.addItem(selectedValue, selectedQuantity);
            }

          } else {

            toAddToCart.set(selectedProductID);

            $('#login-modal').removeClass('hide');

          }

        });

        $(document).on('click', selectors.collectionSelectSizeButton, function (evt) {
          evt.preventDefault();

          $(this).toggleClass('active');

          const currentVariants = $(this).next('[data-variants-options]');

          $(selectors.collectionSelectSizeButton).not($(this)).removeClass('active');
          $('[data-variants-options]').not(currentVariants).addClass('hide');

          currentVariants.toggleClass('hide');

        });

        $(document).on('click', selectors.collectionSelectVariant, function (evt) {
          evt.preventDefault();

          if (!window.theme.settings.loginToAddToCart) {

            if ($(this).data('select-variant')) {
              window.ShopifyAPI.addItem($(this).data('select-variant'), 1);
            }

          } else {

            toAddToCart.set($(this).data('select-variant'));

            $('#login-modal').removeClass('hide');
          }

          if ($(this).data('select-product-id')) {
            const selectedProductID = $(this).data('select-product-id');

            if ($(`#Klaviyo_${selectedProductID}`).html()) {
              _learnq.push(['track', 'Added to Cart', JSON.parse($(`#Klaviyo_${selectedProductID}`).html())]);
            }
          }

        });

        $(document).on('click', selectors.collectionButtonVariantID, function (evt) {
          evt.preventDefault();

          if (!window.theme.settings.loginToAddToCart) {

            var selectedQuantity = $('#Quantity' + $(this).data('product-button-id')).val();

            if ($(this).data('variant-button-id').length != 0 || !$(this).data('variant-button-id')) {
              window.ShopifyAPI.addItem($(this).data('variant-button-id'), selectedQuantity);
            }

          } else {

            toAddToCart.set($(this).data('variant-button-id'));
            $('#login-modal').removeClass('hide');

          }

          if ($(this).data('product-button-id')) {
            const selectedProductID = $(this).data('product-button-id');

            if ($(`#Klaviyo_${selectedProductID}`).html()) {
              _learnq.push(['track', 'Added to Cart', JSON.parse($(`#Klaviyo_${selectedProductID}`).html())]);
            }
          }

        });

        $(document).on('click', selectors.cartRemove, function (evt) {
          evt.preventDefault();

          const line = $(this).data('shopping-cart-remove');

          window.ShopifyAPI.removeItem(line);

        });


        $(document)
          .on('shopify:section:load', function () {
            collection_slider();
            timer();
          });

        collection_slider();
        toggles();

        // Customer Registration
        customerRegistration.init();

        // Shop The Look
        if (window.theme.shopTheLook) {
          ShopTheLook.get(window.theme.shopTheLook.code);
        }

        //Newsletter
        if ($(selectors.newsletterForm).length == 1) {
          const newsletterTags = [];
          const currentTags = $(selectors.contactTags).val();

          if (currentTags) {
            newsletterTags.push(currentTags.trim());
          }

          $(selectors.newsletterSubscribeButton).on('click', function (evt) {

            evt.preventDefault();

            const gender = `gender_${$(this).data('newsletter-subscribe')}`;

            const existingTag = newsletterTags.find(a => a.includes('gender_'));

            if (existingTag) {
              newsletterTags[newsletterTags.indexOf(existingTag)] = gender;
            } else {
              newsletterTags.push(gender);
            }

            $(selectors.contactTags).val(newsletterTags.join(', '));

            $(selectors.newsletterForm).submit();

          });
        }

        $('[data-newsletter-submit]').on('click', function (evt) {
          if ($(this).val().length) {
            evt.preventDefault();
            const $newsletterForm = $(this).closest('form');
            const $inputTags = $newsletterForm.find('[name="contact[tags]"]');
            const $inputTagsValue = $inputTags.val();

            $inputTags.val([$inputTagsValue, $(this).val()].join(', '));

            $newsletterForm.submit();
          }
        });

        // Order Tracking
        if ($(selectors.trackingObject).length == 1) {
          window.theme.getShippingData($(selectors.trackingObject).text());
        }

        if (window.innerWidth < 768) {
          $(cssSelectors.announcementBar_message).on('click', function () {
            $(this).toggleClass('maximo');
          });
        }

        // Update line items
        $(selectors.lineItemQuantityUpdate).on('change', function () {
          const id = $(this).data('line-item-update');
          const quantity = $(this).val();

          window.ShopifyAPI.changeItem(id, quantity).then(res => {
            const { total_price, total_weight } = res;
            $(selectors.cartPrice).html(`<span class="money">${ShopifyAPI.formatMoney(total_price)}</span>`);
            $(selectors.cartWeight).html(ShopifyAPI.formatWeight(total_weight));
          });

        });

        $(document).on('click', selectors.cartContinue, (evt) => {
          // evt.preventDefault();

          const $shoppingCartSelector = $('[data-shopping-cart]');

          $shoppingCartSelector.addClass('hide');

          window.setTimeout(() => {
            $shoppingCartSelector.removeClass('hide');
          }, 1000);

        });

        // Single Product tabs
        $('[data-tab-toggle]').on('click', function () {

          $('[data-tab-toggle]').not($(this)).removeClass('active');
          $('.tab-container').not(`#${$(this).data('tab-toggle')}`).addClass('hide');

          $(this).addClass('active');
          $(`#${$(this).data('tab-toggle')}`).removeClass('hide');

        });

        if ($('body').hasClass('template-cart')) {
          window.localStorage.setItem('continue', document.referrer);
        }

      }
    },
    // Single product page
    'template_product': {
      init: function () {
        // JavaScript to be fired on the home page

        /**
         * Load product videos
         */
        singleProductVideos();
      },
      finalize: function () {
        // JavaScript to be fired on the single product page, after the init

        $('.product-single__thumbnails.small--hide.grid-uniform').slick({
          slide: 'li',
          arrows: true,
          dots: false,
          vertical: true,
          slidesToShow: 8,
          slidesToScroll: 2,
          verticalSwiping: true,
          infinite: false,
          prevArrow: sliderButtonLeft,
          nextArrow: SliderButtonRight,
        });

        // Add text value to labels when option value selected.
        $('.single-option-selector__radio').change(function () {
          if ($(this).is(':checked')) {
            if ($(this).data('index')) {
              const $labelValue = $(`[data-label-option="ProductSelect-${$(this).data('index')}"]`).find('[data-label-name]');

              if ($labelValue.length == 1) {
                $labelValue.text(` - ${$(this).val()}`);
              }
            }
          }
        });

        // Load style code
        const currentProduct = $(selectors.product);

        if (currentProduct.length != 0) {

          const { handle } = JSON.parse(currentProduct.text());

          $(selectors.singleProductStyleCode).each(function () {
            let styleCode = $(this).data('single-option-radio-color');

            if (styleCode) {
              styleCode = styleCode.replace(' ', '-');

              fetch(`/collections/all/${Shopify.handleize(styleCode)}/?view=json`)
                .then(response => response.text())
                .then((data) => {
                  const { products } = JSON.parse(data);
                  const variants = products.filter((product) => product.handle != handle);

                  variants.forEach((variant) => {
                    const { tags } = variant;

                    if (tags.length > 0) {
                      const color = tags.filter((tag) => tag.indexOf('color_') > - 1);
                      const colorName = color[0].replace('color_', '');

                      $(selectors.singleProductStyleCode).append(`<label data-color-handle="${variant.handle}" for="ProductSelect-option-colour-${colorName}" class="has-color">${colorName}</label>`)

                    }

                  });

                })
                .catch((error) => window.console.error(error));

              $(document).on('click', selectors.productColorHandle, function () {
                window.location.pathname = window.location.pathname.replace(handle, $(this).data('color-handle'));
              });
            }
          });
        }

        //Single Product Form override
        if (window.theme.settings.cartType === 'page') {
          const $formContainer = $('#AddToCartForm--product-template');
          const $addToCart = $('#AddToCart--product-template');

          $formContainer.on('submit', function (evt) {
            evt.preventDefault();

            if ($('[data-klaviyo-add-to-cart]').html()) {
              _learnq.push(['track', 'Added to Cart', JSON.parse($('[data-klaviyo-add-to-cart]').html())]);
            }

            if (window.theme.settings.loginToAddToCart) {
              $('#login-modal').removeClass('hide');
              return;
            }

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $('.qty-error').remove();

            itemAddedCallback = function () {
              $addToCart.removeClass('is-adding').addClass('is-added');
              window.ShopifyAPI.onCartUpdate();
            };

            itemErrorCallback = function (XMLHttpRequest) {
              var data = eval('(' + XMLHttpRequest.responseText + ')');
              $addToCart.removeClass('is-adding is-added');

              if (data.message) {
                if (data.status === 422) {
                  $formContainer.after(
                    '<div class="errors qty-error">' + data.description + '</div>'
                  );
                }
              }
            };

            window.ShopifyAPI.addItemFromForm(
              evt.target,
              itemAddedCallback,
              itemErrorCallback
            );


          });

        }

      }
    },
    // Cart Page
    'template_cart': {
      init: function () {
        // JavaScrpt to be fired on the Cart page

        /**
         * Charity Scripts
         */

        if (!$(selectors.charityData).length) {
          return;
        }

        const donationObject = {};
        Shopify.Cart = Shopify.Cart || {};
        Shopify.Cart.charityDonation = {};
        Shopify.Cart.terms = [];

        const { variantList, clearCharityDonationCart } = JSON.parse($(selectors.charityData).text().trim());

        Shopify.Cart.charityDonation.update = function (obj) {
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
              updates: obj,
            },
            dataType: 'json',
            success() {
              window.location.href = '/cart';
            },
            always() {
              $(selectors.buttonCheckout).removeAttr('disabled');
            },
          });
        };

        Shopify.Cart.charityDonation.clear = function () {
          $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success() {
              window.location.href = '/cart';
            },
            always() {
              $(selectors.buttonCheckout).removeAttr('disabled');
            },
          });
        };

        if (clearCharityDonationCart) {
          Shopify.Cart.charityDonation.clear();
        }

        $('[name="attributes[charity-donation]"]').change(function () {
          let selectedDonationAmount = parseInt($(this).attr('data-variantId'), 10);

          function createDonationQuantity(element) {

            if (element === selectedDonationAmount) {
              donationObject[element] = 1;
            } else {
              donationObject[element] = 0;
            }
          }

          $(selectors.buttonCheckout).attr('disabled', 'disabled');

          if ($(this).is(':checked')) {
            variantList.forEach(createDonationQuantity);
            Shopify.Cart.charityDonation.update(donationObject);
          } else {
            selectedDonationAmount = 0;
            variantList.forEach(createDonationQuantity);
            Shopify.Cart.charityDonation.update(donationObject);
          }
        });
      },
      finalize: function () {
        // JavaScript to be fired on the Cart page, after the init
      }
    },
    // Collections
    'template_collection': {
      init: function () {
        if (window.location.pathname === '/collections/vendors' && window.location.search.indexOf('sort') === -1) {
          window.location.search += '&sort=created-descending';
        }
      },
      finalize: function () { }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = P54;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
